import { subMinutes, subYears } from "date-fns";
import * as yup from "yup";
import { isDateBetweenDates } from "../../utils/Date.utils";
import { Length, Max, Patterns, Validation } from "../../utils/Validation.utils";
export const PriorityEntryInitialValues = {
    priorityStatusId: "",
    tags: [],
    inquiredAt: new Date().toISOString(),
    skipEmail: false,
    caregiver: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: ""
    },
    patient: {
        caregiverId: "",
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        preferredLanguages: [],
        gradeLevel: null,
        postalCode: "",
        daysAvailable: [],
        timeAvailable: [],
        conditionIds: [],
        insuranceIds: [],
        therapyCategoryIds: [],
        therapySubCategoryIds: [],
        providerIds: []
    }
};
export const PriorityEntrySchema = yup.object().shape({
    organizationId: yup.string(),
    priorityStatusId: yup.string().nullable(),
    tags: yup.array().of(yup.string().required(Validation.Required)),
    inquiredAt: yup
        .date()
        .required("Please select an inquiry date")
        .test("is-date-valid", "Inquiry date cannot be in the future", (value) => {
        const currentTime = new Date();
        return value && value.getTime() <= currentTime.getTime();
    })
        .test("is-date-valid", "Inquiry date must be between 100 years ago and today", (value) => {
        const startDate = subYears(new Date(), 100);
        const endDate = new Date();
        return isDateBetweenDates(value, startDate, endDate);
    }),
    caregiver: yup.object().shape({
        firstName: yup
            .string()
            .max(Max.FirstName, Validation.Max)
            .required(Validation.Required),
        lastName: yup
            .string()
            .max(Max.LastName, Validation.Max)
            .required(Validation.Required),
        phoneNumber: yup
            .string()
            .required(Validation.Required)
            .matches(Patterns.PhoneNumber, Validation.Invalid)
            .max(Max.PhoneNumber, Validation.Max),
        email: yup
            .string()
            .email(Validation.Invalid)
            .required(Validation.Required)
    }),
    patient: yup.object().shape({
        firstName: yup
            .string()
            .max(Max.FirstName, Validation.Max)
            .required(Validation.Required),
        lastName: yup
            .string()
            .max(Max.LastName, Validation.Max)
            .required(Validation.Required),
        dateOfBirth: yup
            .date()
            .transform((value, originalValue) => originalValue === "" || originalValue === null ? null : value)
            .required("Please select a date of birth")
            .test("is-date-valid", "Please select a date of birth", (value) => {
            const startTime = subMinutes(new Date(), 10);
            return value && value.getTime() < startTime.getTime();
        })
            .test("is-date-valid", "Date of birth must be between 100 years ago and today", (value) => {
            const startDate = subYears(new Date(), 100);
            const endDate = new Date();
            return isDateBetweenDates(value, startDate, endDate);
        }),
        preferredLanguages: yup
            .array()
            .of(yup.mixed().required(Validation.Required)),
        gradeLevel: yup.string().nullable(),
        postalCode: yup
            .string()
            .length(Length.PostalCode, Validation.Length)
            .required(Validation.Required),
        daysAvailable: yup
            .array()
            .of(yup.string().required(Validation.Required)),
        timeAvailable: yup
            .array()
            .of(yup.string().required(Validation.Required)),
        conditionIds: yup
            .array()
            .of(yup.string().required(Validation.Required)),
        insuranceIds: yup
            .array()
            .of(yup.string().required(Validation.Required)),
        therapyCategoryIds: yup
            .array()
            .of(yup.string().required(Validation.Required))
            .required(Validation.Required)
            .min(1, "Please select at least one therapy"),
        therapySubCategoryIds: yup
            .array()
            .of(yup.string().required(Validation.Required))
    })
});
